<template>
  <div
    class="
      navigator-menu-bar
      d-flex
      justify-space-between
      align-center
      py-4
      beige-pastel-light
    "
    style="width: 100%"
  >
    <base-button
      v-if="!hideBackButton"
      class="navigator-menu-bar__btn"
      :aria-label="$t('actions.back')"
      no-hover
      @click="handleClickBack"
    >
      <base-icon mdi="arrow-left"></base-icon>
      {{ $t('actions.back') }}
    </base-button>
    <base-button
      class="navigator-menu-bar__btn"
      :aria-label="$t('commons.search')"
      no-hover
      @click="openSearch"
    >
      <base-icon mdi="magnify"></base-icon>
      {{ $t('commons.search') }}
    </base-button>
    <base-button
      class="navigator-menu-bar__btn"
      :to="localePath('/account')"
      :aria-label="$t('commons.account')"
      no-hover
      @click.native="uiEventAccount"
    >
      <base-icon mdi="account-outline"></base-icon>
      {{ $t('commons.account') }}

      <div
        v-if="isLoggedIn"
        class="navigator-menu-bar__badge navigator-menu-bar__badge--account"
      >
        <base-icon
          svg="M9,20.42L2.79,14.21L5.62,11.38L9,14.77L18.88,4.88L21.71,7.71L9,20.42Z"
          size="10px"
          class="white--text"
        ></base-icon>
      </div>
    </base-button>
    <base-button
      class="navigator-menu-bar__btn"
      :aria-label="$t('actions.close')"
      no-hover
      @click="handleClickClose"
    >
      <base-icon mdi="close"></base-icon>
      {{ $t('actions.close') }}
    </base-button>
  </div>
</template>

<script>
import BaseIcon from '~/components/base/icon/BaseIcon'
import { useUiEvent, useUIState, useUser } from '~/composables'
import {
  NAVIGATION_DRAWER_STATE,
  NAVIGATION_SEARCH_STATE,
} from '~/services/UiStates'

export default {
  name: 'NavigatorMenuBar',
  components: { BaseIcon },
  props: {
    hideBackButton: {
      type: Boolean,
      default: false,
    },
  },
  setup(_, { root, emit }) {
    const uiEventSearch = useUiEvent(root, 'search', 'navigator')
    const uiEventAccount = useUiEvent(root, 'account', 'navigator')
    const uiEventBack = useUiEvent(root, 'back-top', 'navigator')
    const uiEventClose = useUiEvent(root, 'close-top', 'navigator')

    const { isLoggedIn } = useUser(root)

    const { switchState: toggleNavigationDrawer } = useUIState(
      root,
      NAVIGATION_DRAWER_STATE
    )

    const { switchState: toggleNavigationSearch } = useUIState(
      root,
      NAVIGATION_SEARCH_STATE
    )

    const openSearch = () => {
      toggleNavigationDrawer(false)
      toggleNavigationSearch(true)

      uiEventSearch()
    }

    const handleClickBack = () => {
      emit('click:back')

      uiEventBack()
    }

    const handleClickClose = () => {
      emit('click:close')

      uiEventClose()
    }

    return {
      openSearch,
      uiEventAccount,
      isLoggedIn,
      handleClickBack,
      handleClickClose,
    }
  },
}
</script>

<style lang="scss">
.navigator-menu-bar {
  &__btn {
    flex: 1 1 100%;
    font-size: 9px;
    padding: 0;

    .base-button__content {
      text-transform: capitalize;
      flex-direction: column;
      height: inherit;
    }
  }

  &__badge {
    position: absolute;
    background: map-get($shades, 'frontend-primary');
    border-radius: 10px;
    padding: 4px 6px;
    line-height: 1;
    right: -1px;
    color: #fff;
    height: 20px;
    bottom: -10px;
    min-width: 20px;
    display: inline-block;
    font-size: 12px;

    &--top,
    &--account {
      top: -5px;
      right: calc(50% - 25px);
    }

    &--account {
      padding: 1px 3px;
      height: 16px;
      min-width: 11px;
    }
  }
}
</style>
